import React, { useState, useEffect } from 'react'
import Home from './pages/Home/Home'
import Restaurant from './pages/Restaurant/Restaurant'
import Footer from './components/Footer/Footer'
import Navbar from './components/Navbar/Navbar'
import { Route, Routes } from 'react-router-dom'
import Cart from './pages/Cart/Cart'
import LoginPopup from './components/LoginPopup/LoginPopup'
import ResetPasswordModal from './components/ResetPasswordModal/ResetPasswordModal'
import PlaceOrder from './pages/PlaceOrder/PlaceOrder'
import OrderDetails from './pages/OrderDetails/OrderDetails'
import MyOrders from './pages/MyOrders/MyOrders'
import ProfilePage from './pages/ProfilePage/ProfilePage'
import ProfileModal from './components/ProfileModal/ProfileModal'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Verify from './pages/Verify/Verify'
import Payment from './pages/Payment/Payment'
import RestaurantApply from './pages/RestaurantApply/RestaurantApply'
import DriverApply from './pages/DriverApply/DriverApply'
import ResetPassword from './pages/ResetPassword/ResetPassword'
import SharedCart from './pages/SharedCart/SharedCart'
import { useAuth } from './Context/AuthContext'
import TermsOfService from './pages/Legal/TermsOfService'
import PrivacyPolicy from './pages/Legal/PrivacyPolicy'
import DeleteAccount from './pages/Legal/DeleteAccount'

const App = () => {
  const { showLogin, showResetPassword, setShowLogin, setShowResetPassword } = useAuth();
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [toastMarginTop, setToastMarginTop] = useState('60px');

  // Update toast margin based on screen size
  useEffect(() => {
    const updateToastMargin = () => {
      if (window.innerWidth <= 480) {
        setToastMarginTop('120px'); // Extra space for wrapped mobile navbar
      } else if (window.innerWidth <= 768) {
        setToastMarginTop('90px');  // Medium space for tablet navbar
      } else {
        setToastMarginTop('60px');  // Normal space for desktop navbar
      }
    };

    // Initial check
    updateToastMargin();

    // Listen for window resize
    window.addEventListener('resize', updateToastMargin);

    return () => window.removeEventListener('resize', updateToastMargin);
  }, []);

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        toastStyle={{
          marginTop: toastMarginTop,
          zIndex: 9999
        }}
      />
      {showLogin ? <LoginPopup setShowLogin={setShowLogin} setShowResetPassword={setShowResetPassword}/> : <></>}
      {showResetPassword ? <ResetPasswordModal setShowResetPassword={setShowResetPassword} setShowLogin={setShowLogin}/> : <></>}
      {showProfileModal && <ProfileModal isOpen={showProfileModal} onClose={() => setShowProfileModal(false)} />}
      
      <div className='app-container'>
        <Navbar setShowProfileModal={setShowProfileModal} />
        
        <main className='main-content'>
          <Routes>
            <Route path='/' element={<Home setShowProfileModal={setShowProfileModal} />}/>
            <Route path='/restaurant/:restaurantId' element={<Restaurant />}/>
            <Route path='/cart' element={<Cart />}/>
            <Route path='/order-details' element={<OrderDetails />}/>
            <Route path='/checkout' element={<PlaceOrder />}/>
            <Route path='/order' element={<PlaceOrder />}/>
            <Route path='/payment' element={<Payment />}/>
            <Route path='/myorders' element={<MyOrders />}/>
            <Route path='/profile' element={<ProfilePage />}/>
            <Route path='/verify' element={<Verify />}/>
            <Route path='/reset-password' element={<ResetPassword />}/>
            <Route path='/restaurant-apply' element={<RestaurantApply />}/>
            <Route path='/driver-apply' element={<DriverApply />}/>
            <Route path='/cart/shared/:shareId' element={<SharedCart />}/>
            <Route path='/terms' element={<TermsOfService />}/>
            <Route path='/privacy' element={<PrivacyPolicy />}/>
            <Route path='/delete-account' element={<DeleteAccount />}/>
          </Routes>
        </main>
        
        <Footer />
      </div>
    </>
  )
}

export default App
